import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24">
      <div className="container">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 lg:pr-12 mb-10 lg:mb-0">
            <h1 className="font-semibold mb-6 text-center lg:text-left text-3xl md:text-4xl leading-snug">
              Googleの口コミ対応を、<br className="hidden md:block" />
              もっとスマートに、もっと自動で
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 text-center lg:text-left leading-relaxed">
              AIが口コミの<span className="font-medium">収集・返信・分析</span>をすべて自動化。<br />
              <span className="text-blue-600 font-semibold">1日たったの100円</span>で、お店の評判管理をシンプルに。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4">
              <a href="#pricing" className="btn btn-primary w-full sm:w-auto">
                今すぐ始める
              </a>
              <a href="#features" className="btn btn-secondary w-full sm:w-auto ring-1 ring-gray-400">
                デモを見る
              </a>
            </div>
          </div>
          <div className="lg:w-1/2">
            <div className="relative">
              <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-apple-lg">
                <img 
                  src="/img/hero.png" 
                  alt="Google review management dashboard" 
                  className="w-full h-auto"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-apple text-blue-600 text-lg font-medium">
                多店舗管理対応
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;